import type { CircleShape } from "@gettactic/map-builder/src/types";
import React from "react";
import { buildWorldShapeTransform } from "../shapeTransform";

export interface CircleSvgProps {
  shape: CircleShape;
}

/** Circles are centred on (x, y); width/height are the diameters. */
export const CircleSvg: React.FC<CircleSvgProps> = ({ shape }) => (
  <ellipse
    cx={shape.x}
    cy={shape.y}
    rx={shape.width / 2}
    ry={shape.height / 2}
    fill={shape.noFill ? "none" : shape.color || "#000000"}
    stroke={shape.stroke || "none"}
    strokeWidth={shape.strokeWidth || 0}
    transform={buildWorldShapeTransform(shape)}
  />
);
